<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { MP } from './map'    //引入上面创建的map.js文件
import { BMPGL } from './bmpgl'    //引入上面创建的map.js文件
export default {
    name: "App",
    data(){
    return {
      ak: "K1vdYnxesH3PX7l4fZ5UOSW0BLnZqZ6a",
    }
  },
  async mounted(){
      await MP(this.ak);
      await BMPGL(this.ak);
  },
};
</script>

<style> 
.el-message-box {
  width: 30%;
}
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
body .el-table::before {
    z-index: inherit;
}
</style>



// WEBPACK FOOTER //
// src/App.vue